import React, { Component } from 'react'
import Parent from './Parent'
import Loading from './Loading'
import PropTypes from 'prop-types'
import InputRow from './InputRow'
export default class GuardianInformation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      prefixData: [],
      guardianRelationship: '',
      guardianPrefix: '',
      guardianFName: this.props.guardianInfo.RelationFirstName || '',
      guardianMName: this.props.guardianInfo.RelationMiddleName || '',
      guardianLName: this.props.guardianInfo.RelationLastName || '',
      guardianProfession: this.props.guardianInfo.Profession || '',
      guardianPhone: this.props.guardianInfo.MobileNumber || '',
      guardianEmail: this.props.guardianInfo.RelationEmail || '',
      guardianAddress:this.props.guardianInfo.GuardianAddress,
      loading: true,
      disableAll: false,
      error: '',
      relationshipData: []
    }
    this.relationshipUpdate = this.relationshipUpdate.bind(this)
  }

  componentDidMount () {
    fetch(`${process.env.REACT_APP_API_URL}/api/parentinformation/getprefixes`)
      .then(res => res.json())
      .then(res => {
        this.setState({ prefixData: res })
        if (res.length) {
          this.setState({ guardianPrefix: parseInt(this.props.guardianInfo.RelationPrefix) || '' })
        }
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}/api/guardianinformation/getrelations`))
      .then(res => res.json())
      .then(res => {
        this.setState({ relationshipData: res, loading: false })
        if (res.length) {
          this.setState({ guardianRelationship: parseInt(this.props.guardianInfo.RelationType) || '' })
          if (parseInt(this.props.guardianInfo.RelationType) === this.props.fatherId || parseInt(this.props.guardianInfo.RelationType) === this.props.motherId) {
            this.setState({ disableAll: true })
          }
        }
      })
  }

  relationshipUpdate (e) {
    if (parseInt(e) === this.props.fatherId) {
      const fatherInfo = this.props.fatherInfo
      this.setState({
        guardianRelationship: this.props.fatherId,
        guardianPrefix: fatherInfo.prefix || fatherInfo.RelationPrefix || 0,
        guardianFName: fatherInfo.firstName || fatherInfo.RelationFirstName || '',
        guardianMName: fatherInfo.middleName || fatherInfo.RelationMiddleName || '',
        guardianLName: fatherInfo.familyName || fatherInfo.RelationLastName || '',
        guardianProfession: fatherInfo.profession || fatherInfo.Profession || '',
        guardianPhone: fatherInfo.mobileNumber || fatherInfo.MobileNumber || '',
        guardianEmail: fatherInfo.email || fatherInfo.RelationEmail || '',
        disableAll: true
      })
      this.props.collectState('Guardian', {
        guardianRelationship: this.props.fatherId,
        guardianPrefix: fatherInfo.prefix || fatherInfo.RelationPrefix || 0,
        guardianFName: fatherInfo.firstName || fatherInfo.RelationFirstName || '',
        guardianMName: fatherInfo.middleName || fatherInfo.RelationMiddleName || '',
        guardianLName: fatherInfo.familyName || fatherInfo.RelationLastName || '',
        guardianProfession: fatherInfo.profession || fatherInfo.Profession || '',
        guardianPhone: fatherInfo.mobileNumber || fatherInfo.MobileNumber || '',
        guardianEmail: fatherInfo.email || fatherInfo.RelationEmail || ''
      })
    } else if (parseInt(e) === this.props.motherId) {
      const motherInfo = this.props.motherInfo
      this.setState({
        guardianRelationship: this.props.motherId,
        guardianPrefix: motherInfo.prefix || motherInfo.RelationPrefix || 0,
        guardianFName: motherInfo.firstName || motherInfo.RelationFirstName || '',
        guardianMName: motherInfo.middleName || motherInfo.RelationMiddleName || '',
        guardianLName: motherInfo.familyName || motherInfo.RelationLastName || '',
        guardianProfession: motherInfo.profession || motherInfo.Profession || '',
        guardianPhone: motherInfo.mobileNumber || motherInfo.MobileNumber || '',
        guardianEmail: motherInfo.email || motherInfo.RelationEmail || '',
        disableAll: true
      })
      this.props.collectState('Guardian', {
        guardianRelationship: this.props.motherId,
        guardianPrefix: motherInfo.prefix || motherInfo.RelationPrefix || 0,
        guardianFName: motherInfo.firstName || motherInfo.RelationFirstName || '',
        guardianMName: motherInfo.middleName || motherInfo.RelationMiddleName || '',
        guardianLName: motherInfo.familyName || motherInfo.RelationLastName || '',
        guardianProfession: motherInfo.profession || motherInfo.Profession || '',
        guardianPhone: motherInfo.mobileNumber || motherInfo.MobileNumber || '',
        guardianEmail: motherInfo.email || motherInfo.RelationEmail || ''
      })
    } else {
      if ([this.props.fatherId, this.props.motherId].indexOf(parseInt(this.state.guardianRelationship)) !== -1) {
        this.setState({
          guardianRelationship: e,
          guardianPrefix: '',
          guardianFName: '',
          guardianMName: '',
          guardianLName: '',
          guardianProfession: '',
          guardianPhone: '',
          guardianEmail: ''
        })
        this.props.collectState('Guardian', {
          guardianRelationship: e,
          guardianPrefix: '',
          guardianFName: '',
          guardianMName: '',
          guardianLName: '',
          guardianProfession: '',
          guardianPhone: '',
          guardianEmail: ''
        })
      } else {
        this.setState({
          guardianRelationship: e,
          guardianPrefix: this.state.guardianPrefix,
          guardianFName: this.state.guardianFName,
          guardianMName: this.state.guardianMName,
          guardianLName: this.state.guardianLName,
          guardianProfession: this.state.guardianProfession,
          guardianPhone: this.state.guardianPhone,
          guardianEmail: this.state.guardianEmail
        })
        this.props.collectState('Guardian', {
          guardianRelationship: e,
          guardianPrefix: this.state.guardianPrefix,
          guardianFName: this.state.guardianFName,
          guardianMName: this.state.guardianMName,
          guardianLName: this.state.guardianLName,
          guardianProfession: this.state.guardianProfession,
          guardianPhone: this.state.guardianPhone,
          guardianEmail: this.state.guardianEmail
        })
      }
      this.setState({ guardianRelationship: e, disableAll: false })
    }
  }

  render () {
    const validationError = this.props.error
    const {
      prefixData,
      guardianRelationship,
      guardianPrefix,
      guardianFName,
      guardianMName,
      guardianLName,
      guardianProfession,
      guardianPhone,
      guardianEmail,
      guardianAddress,
      loading,
      disableAll,
      error,
      relationshipData
    } = this.state
    if (loading) {
      return (<Loading />)
    }
    return (
     
      <div>
        <p style={{ color: 'red' }}>{error}</p>
        {[this.props.fatherId, this.props.motherId].indexOf(parseInt(guardianRelationship)) !== -1
          ? [this.props.fatherId].indexOf(parseInt(guardianRelationship)) !== -1 ? <div className="guardian">
            <Parent
              guardian={true}
              relationshipData={relationshipData}
              relationship={guardianRelationship}
              relationshipUpdate={this.relationshipUpdate}
              prefixData={prefixData}
              onChangePrefix={() => {}}
              selectedPrefix={this.props.fatherInfo.RelationPrefix}
              fName={this.props.fatherInfo.RelationFirstName}
              onChangeFName={() => {}}
              mName={this.props.fatherInfo.RelationMiddleName}
              onChangeMName={() => {}}
              lName={this.props.fatherInfo.RelationLastName}
              onChangeLName={() => {}}
              profession={this.props.fatherInfo.Profession}
              onChangeProfession={() => {}}
              mobileNumber={this.props.fatherInfo.MobileNumber}
              onChangeNumber={() => {}}
              email={this.props.fatherInfo.RelationEmail}
              emailRequired={false}
              onChangeEmail={() => {}}
              disableAll={disableAll}
              errRelation={validationError.guardianRelationship ? validationError.guardianRelationship : ''}
              errPrefix={validationError.guardianPrefix ? validationError.guardianPrefix : ''}
              errFName={validationError.guardianFName ? validationError.guardianFName : ''}
              errMName={validationError.guardianMName ? validationError.guardianMName : ''}
              errLName={validationError.guardianLName ? validationError.guardianLName : ''}
              errProfession={validationError.guardianProfession ? validationError.guardianProfession : ''}
              errMobile={validationError.guardianPhone ? validationError.guardianPhone : ''}
              errEmail={validationError.guardianEmail ? validationError.guardianEmail : ''}
            />
          
          </div>
            : [this.props.motherId].indexOf(parseInt(guardianRelationship)) !== -1
              ? <div className="guardian">
                <Parent
                  guardian={true}
                  relationshipData={relationshipData}
                  relationship={guardianRelationship}
                  relationshipUpdate={this.relationshipUpdate}
                  prefixData={prefixData}
                  onChangePrefix={() => {}}
                  selectedPrefix={this.props.motherInfo.RelationPrefix}
                  fName={this.props.motherInfo.RelationFirstName}
                  onChangeFName={() => {}}
                  mName={this.props.motherInfo.RelationMiddleName}
                  onChangeMName={() => {}}
                  lName={this.props.motherInfo.RelationLastName}
                  onChangeLName={() => {}}
                  profession={this.props.motherInfo.Profession}
                  onChangeProfession={() => {}}
                  mobileNumber={this.props.motherInfo.MobileNumber}
                  onChangeNumber={() => {}}
                  email={this.props.motherInfo.RelationEmail === null || this.props.motherInfo.RelationEmail==='' ? null: this.props.motherInfo.RelationEmail}
                  emailRequired={false}
                  onChangeEmail={(val) => {
                    this.setState({ guardianEmail: val })
                    this.props.collectState('Guardian', {
                      guardianRelationship: guardianRelationship,
                      guardianPrefix: guardianPrefix,
                      guardianFName: guardianFName,
                      guardianMName: guardianMName,
                      guardianLName: guardianLName,
                      guardianProfession: guardianProfession,
                      guardianPhone: guardianPhone,
                      guardianEmail: val
                    })
                  }}
                  //onChangeEmail={() => {}}
                  disableAll={disableAll}
                  errRelation={validationError.guardianRelationship ? validationError.guardianRelationship : ''}
                  errPrefix={validationError.guardianPrefix ? validationError.guardianPrefix : ''}
                  errFName={validationError.guardianFName ? validationError.guardianFName : ''}
                  errMName={validationError.guardianMName ? validationError.guardianMName : ''}
                  errLName={validationError.guardianLName ? validationError.guardianLName : ''}
                  errProfession={validationError.guardianProfession ? validationError.guardianProfession : ''}
                  errMobile={validationError.guardianPhone ? validationError.guardianPhone : ''}
                  errEmail={validationError.guardianEmail ? validationError.guardianEmail : ''}
                />
              </div>
              : null
          : <div className="guardian">
            <Parent
              guardian={true}
              relationshipData={relationshipData}
              relationship={guardianRelationship}
              relationshipUpdate={this.relationshipUpdate}
              prefixData={prefixData}
              onChangePrefix={(val) => {
                this.setState({ guardianPrefix: val })
                this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: val,
                  guardianFName: guardianFName,
                  guardianMName: guardianMName,
                  guardianLName: guardianLName,
                  guardianProfession: guardianProfession,
                  guardianPhone: guardianPhone,
                  guardianEmail: guardianEmail
                })
              }}
              selectedPrefix={guardianPrefix}
              fName={guardianFName}
              onChangeFName={(val) => {
                this.setState({ guardianFName: val })
                this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: val,
                  guardianMName: guardianMName,
                  guardianLName: guardianLName,
                  guardianProfession: guardianProfession,
                  guardianPhone: guardianPhone,
                  guardianEmail: guardianEmail
                })
              }}
              mName={guardianMName}
              onChangeMName={(val) => {
                this.setState({ guardianMName: val })
                this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: guardianFName,
                  guardianMName: val,
                  guardianLName: guardianLName,
                  guardianProfession: guardianProfession,
                  guardianPhone: guardianPhone,
                  guardianEmail: guardianEmail
                })
              }}
              lName={guardianLName}
              onChangeLName={(val) => {
                this.setState({ guardianLName: val })
                this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: guardianFName,
                  guardianMName: guardianMName,
                  guardianLName: val,
                  guardianProfession: guardianProfession,
                  guardianPhone: guardianPhone,
                  guardianEmail: guardianEmail
                })
              }}
              profession={guardianProfession}
              onChangeProfession={(val) => {
                this.setState({ guardianProfession: val })
                this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: guardianFName,
                  guardianMName: guardianMName,
                  guardianLName: guardianLName,
                  guardianProfession: val,
                  guardianPhone: guardianPhone,
                  guardianEmail: guardianEmail
                })
              }}
              mobileNumber={guardianPhone}
              onChangeNumber={(val) => {
                this.setState({ guardianPhone: val })
                this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: guardianFName,
                  guardianMName: guardianMName,
                  guardianLName: guardianLName,
                  guardianProfession: guardianProfession,
                  guardianPhone: val,
                  guardianEmail: guardianEmail
                })
              }}
              email={guardianEmail}
              emailRequired={false}
              onChangeEmail={(val) => {
                this.setState({ guardianEmail: val })
                this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: guardianFName,
                  guardianMName: guardianMName,
                  guardianLName: guardianLName,
                  guardianProfession: guardianProfession,
                  guardianPhone: guardianPhone,
                  guardianEmail: val
                })
              }}
              disableAll={disableAll}
              errRelation={validationError.guardianRelationship ? validationError.guardianRelationship : ''}
              errPrefix={validationError.guardianPrefix ? validationError.guardianPrefix : ''}
              errFName={validationError.guardianFName ? validationError.guardianFName : ''}
              errMName={validationError.guardianMName ? validationError.guardianMName : ''}
              errLName={validationError.guardianLName ? validationError.guardianLName : ''}
              errProfession={validationError.guardianProfession ? validationError.guardianProfession : ''}
              errMobile={validationError.guardianPhone ? validationError.guardianPhone : ''}
              errEmail={validationError.guardianEmail ? validationError.guardianEmail : ''}

            />
          </div>

      
        }
         <InputRow
                name="text"
                value={guardianAddress}
                rowName="Address"
                required = "*"
                errMsg={validationError.guardianAddress ? validationError.guardianAddress : ''}
                onChange={(val) => {
                  this.setState({ guardianAddress: val })
                  this.props.collectState('Guardian', {
                  guardianRelationship: guardianRelationship,
                  guardianPrefix: guardianPrefix,
                  guardianFName: guardianFName,
                  guardianMName: guardianMName,
                  guardianLName: guardianLName,
                  guardianProfession: guardianProfession,
                  guardianPhone: guardianPhone,
                  guardianEmail: guardianEmail,
                  guardianAddress : val
                })
              }}
              />

        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>
      </div>
    )
  }
}
GuardianInformation.propTypes = {
  onSave: PropTypes.func.isRequired,
  motherInfo: PropTypes.object.isRequired,
  fatherInfo: PropTypes.object.isRequired,
  guardianInfo: PropTypes.object,
  incompleteApplicationId: PropTypes.number.isRequired,
  collectState: PropTypes.func,
  error: PropTypes.object,
  motherId: PropTypes.number.isRequired,
  fatherId: PropTypes.number.isRequired
}
